import { createFileRoute } from "@tanstack/react-router"

import { LegalVersionPage } from "@/components/content/legal-version-page"
import {
  currentLegalVersion,
  lazyLegalModules,
  loadCurrentLegalVersion,
  resolveLegalVersions,
} from "@/lib/legal-versions"
import { seoMeta } from "@/lib/seo"

const modules = lazyLegalModules(import.meta.glob("../-content/credit-terms/*.md"))

export const Route = createFileRoute("/_content/credit-terms/")({
  head: () =>
    seoMeta({
      title: "Credit Terms",
      description: "How you buy and use Credits for paid features on Entire.",
      url: "https://entire.com/credit-terms",
      image: "https://entire.com/og/page/credit-terms.png",
    }),
  loader: () => loadCurrentLegalVersion(modules),
  component: CreditTermsPage,
})

function CreditTermsPage() {
  const { asOf } = Route.useLoaderData()
  const versions = resolveLegalVersions(modules, asOf)
  const current = currentLegalVersion(versions)!
  return <LegalVersionPage basePath="/credit-terms" version={current} versions={versions} />
}
